import { actionTypes } from './actions';

export const initialState = {
  currentPlayingVoiceId: null,
  currentPlayingVoiceItemVariant: null,
  currentPlayingVoiceSection: null,
};

const audioVoiceLibraryReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_PLAYING_VOICE_ID: {
      const { voiceId } = action;
      return { ...state, currentPlayingVoiceId: voiceId };
    }

    case actionTypes.SET_CURRENT_PLAYING_VOICE_ITEM_VARIANT: {
      const { variant } = action;
      return { ...state, currentPlayingVoiceItemVariant: variant };
    }

    case actionTypes.SET_CURRENT_PLAYING_VOICE_SECTION: {
      const { section } = action;
      return { ...state, currentPlayingVoiceSection: section };
    }

    default:
      return state;
  }
};

export default audioVoiceLibraryReducer;
